import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';
import { JwtService } from "./jwt.service";
import { JwtHelper, tokenNotExpired } from "angular2-jwt";

@Injectable()
export class AuthService {

    public token: string;


    constructor(
        private apiService: ApiService,
        private jwtService: JwtService
    ) {

    }

    get isAuthenticated(): boolean {

        this.token = this.jwtService.getToken();

        // Do this in JWT
        try {

            if (this.token && tokenNotExpired()) {

                return true;

            } else {

                return false;
            }

        } catch (e) {

            return false;
        }
    }

    refreshToken() {
        return this.apiService.post('refresh-token').subscribe(
            (res) => {
                this.jwtService.saveToken(res['refreshedToken']);
                location.reload();
            }
        );
    }

    login(body): Observable<User> {
        return this.apiService.post('login', body);
    }

    user(): Observable<User> {
        return this.apiService.get('user');
        // const currentUser = localStorage.getItem('currentUser');
        // return JSON.parse(currentUser);
    }

    sendPasswordResetMail(body) {
        return this.apiService.post('password/send-reset-mail', body);
    }

    resetPassword(body) {
        return this.apiService.post('password/reset', body);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/auth.service.ts